import React, { Component } from 'react';
import apiConfig from '../../api/apiConfig'
import {Link} from 'react-router-dom';
import Icon from 'react-icons-kit';
import {androidDelete} from 'react-icons-kit/ionicons/androidDelete';
import {edit} from 'react-icons-kit/ionicons/edit';

import './style.css';

class EditSubQuestion extends Component {
  constructor(props){
    super(props)
   

    this.state={
        subQuesID : '',
        sub_ques_id : '',
        catID : "",
        quesID : "",
        sec_sub_ques : "",
        order_no :"",
        questions:"",
        selectionType : "",
        showaddSecondSubQuestionbutton : false,
        validationMsg: {},
    }

    this.onChange = this.onChange.bind(this);
    this.onChangeOption = this.onChangeOption.bind(this);
    this.onChangeRadio = this.onChangeRadio.bind(this);
    this.updatesubQuestion = this.updatesubQuestion.bind(this);
  }

  componentWillMount(){
   
    if(this.props.demoGraphicsEditSubQuestionSuccess && this.props.demoGraphicsEditSubQuestionData){
      this.setState({
      sub_ques_id :this.props.demoGraphicsEditSubQuestionData[0]._id,
      subQuesID :this.props.demoGraphicsEditSubQuestionData[0].sub_ques_id,
      catID : this.props.demoGraphicsEditSubQuestionData[0].cat_id,
      quesID : this.props.demoGraphicsEditSubQuestionData[0].ques_id,
      sec_sub_ques : this.props.demoGraphicsEditSubQuestionData[0].sec_sub_ques,
      order_no : this.props.demoGraphicsEditSubQuestionData[0].orderSubQues+"",
      questions : this.props.demoGraphicsEditSubQuestionData[0].questions,
      selectionType : this.props.demoGraphicsEditSubQuestionData[0].selectionType,
      });

      if(this.props.demoGraphicsEditSubQuestionData[0].sec_sub_ques == true){
        this.setState({ showaddSecondSubQuestionbutton : true});
      }else{
        this.setState({ showaddSecondSubQuestionbutton : false});
      }
   }
  }

  componentWillReceiveProps(nextProps){
    
   if(nextProps.subQuestionUpdateSuccess && nextProps.subQuestionUpdateSuccessMessage){
    alert(nextProps.subQuestionUpdateSuccessMessage);
    
    if(this.state.sec_sub_ques == true){
      this.setState({ showaddSecondSubQuestionbutton : true});
    }else{
      this.setState({ showaddSecondSubQuestionbutton : false});
    }
    this.props.emptyDemoSubQuestionResponse();

   }else if(nextProps.subQuestionUpdateFailMessage){
    alert(nextProps.subQuestionUpdateFailMessage);
    
    if(!this.state.sec_sub_ques){
      this.setState({ showaddSecondSubQuestionbutton : false});
    }
    this.props.emptyDemoSubQuestionResponse();
   }
  }

  onChange(e){
    this.setState({[e.target.name]: e.target.value});
  }

  onChangeOption(e){
    this.setState({[e.target.name]: e.target.value});
  }

  onChangeRadio(e){
    this.setState({[e.target.name]: e.target.value});
  }

  handleValidation() {
    
    let valid = true;
    let error = {};

    if (this.state.questions === "") {
        error.questions = "Can't leave empty";
        valid = false;
    }
    if(this.state.selectionType === ""){
        error.selectionType = "Can't leave unselect";
        valid = false;
    }

    if(this.state.sec_sub_ques === ""){
        error.sec_sub_ques = "Can't leave unselect";
        valid = false;
    }
   
    if (this.state.order_no === "") {
      error.order_no = "Please enter order_no";
      valid = false;
		}else if (!this.state.order_no.match(/^\d*$/)){
      error.order_no = "Please only enter numeric characters in order_no";
      valid = false;
    }
    this.setState({ validationMsg: error });
		return valid;
	}

    updatesubQuestion(){
    let subQuesData = {};
      if (this.handleValidation()) {
        subQuesData._id =  this.state.sub_ques_id;
        subQuesData.cat_id = this.state.catID;
        subQuesData.ques_id = this.state.quesID;
        subQuesData.orderSubQues = this.state.order_no;   
        subQuesData.questions = this.state.questions;
        subQuesData.selectionType = this.state.selectionType;  
        subQuesData.sec_sub_ques = this.state.sec_sub_ques;
        this.props.updatesubQuestion(subQuesData);  
    }
  }

  categoryList(){
    this.props.categoryList();
  }

  gotoBack(){
    window.history.back();
  }

  softDeleteSubOption(data){
    this.props.softDeleteSubOption(data);
  }

  gotoSecondSubquestionView(){
    let catID = this.state.catID;
    let quesID = this.state.quesID;
    let subQuesID = this.state.subQuesID;
    this.props.gotoSecondSubquestionView( catID, quesID, subQuesID);
  }


  render() {

      let msg="";
      if(this.props.studyMessage){
        msg = this.props.studyMessage;
      }

      let OptionsList = "";
    if(this.props.demoGraphicsCatSubQuesOptionsListSuccess && this.props.demoGraphicsCatSubQuesOptionsListData && this.props.demoGraphicsCatSubQuesOptionsListData.length > 0){
        let options = this.props.demoGraphicsCatSubQuesOptionsListData;
        OptionsList = Object.keys(options).map((item, index) => {
        let optionItem = options[item];


        return <tr key={index} >
            <td style ={{ textAlign : "center" }}>{index+1}</td>
            <td >{ this.state.questions}</td>
            <td>{optionItem.options}</td>
            <td style ={{ textAlign : "center" }}>{optionItem.order_no}</td>
            <td className = "cat_action">
            <Link to={{
             pathname: '/editSubOption/&sop:'+ optionItem._id,
             
              }}>
              < Icon icon={edit} size={30} style={{ color: '#336699' }}/>
            </Link>
            <button onClick = {this.softDeleteSubOption.bind(this, optionItem)} className = "removebutton">< Icon icon={androidDelete} size={30} style={{ color: '#EF233C' }}/></button>            
            </td>
          </tr>
          });
    }else{
      OptionsList = "No data"
    }

    let showaddSecondSubQuestionBtn = "";
    if(this.state.showaddSecondSubQuestionbutton){
      showaddSecondSubQuestionBtn = <button className = "demoRightbtn"  onClick={this.gotoSecondSubquestionView.bind(this)}>Subquestions</button>
    }

      return (
        <div className = "regPage">
            <div className = "createnewstudy">
                <div className = "studyheader"><h1>Sub Question</h1></div>
            <div className = "setbackbutton">
            <br/>

            
            <button className = "editstudybackbtn" onClick={this.gotoBack}  >Back</button>
            {showaddSecondSubQuestionBtn}
            <br/>
            <div className = "studypage">

            <div style={{ color: "red", textAlign:"center" }} >{this.state.validationMsg.selectionType}</div><br/><br/>

            <label id = "addQuesLabel">Do you want to add Sub question ? </label>
            
            <input type="radio" name="sec_sub_ques" value="true"  onChange={this.onChangeRadio}  defaultChecked = {true == this.state.sec_sub_ques} /> Yes
            <input style = {{marginLeft : "10%"}} type="radio" name="sec_sub_ques" value="false" onChange={this.onChangeRadio} defaultChecked={false == this.state.sec_sub_ques} /> No
            
            <div style={{ color: "red", textAlign:"center"}} >{this.state.validationMsg.sec_sub_ques}</div><br/><br/>

            <div>

            <label id = "lbl1">Question</label>
            <input type="text" className = "textFields" placeholder = "Enter question" name="questions" value={this.state.questions} onChange={this.onChange} />
            <div style={{ color: "red", textAlign:"center", marginTop: "-15px" }} >{this.state.validationMsg.questions}</div><br/>

            <label id = "lbl1">Order No</label>
            <input type="text" className = "textFields" placeholder = "Category Order" name="order_no" value={this.state.order_no} onChange={this.onChange} />
            <div style={{ color: "red", textAlign:"center", marginTop: "-15px" }} >{this.state.validationMsg.order_no}</div><br/><br/>
            
            <label id = "lbl1">Option type</label>
            <select  name="selectionType" className="selectOptionType" value={this.state.selectionType} onChange={this.onChangeOption}>
              <option value="">Select Option type</option>
              <option value="select">select</option>
              <option value="checkBox">checkBox</option>
            </select >


            
            <div className = "stdbtn"><button  className="studySavebtn" onClick={this.updatesubQuestion}  >Update</button></div><br/>
            </div>
            <p className = "studyMSG">{msg}</p>
            </div>
          </div>
        
        {/* //............................. */}

        <hr/>

          <div className = "catQuesListHeading"><h3>Sub Question's Option List</h3></div>

          <Link to={{
                pathname: '/demoAddSubOption/&q:'+ this.state.quesID +'/&sq:'+ this.state.subQuesID,
              
                }}><button  className = "createCouponbtn" >
          Add Option</button></Link>

          <div className = "autoscroll">
          <table className = "demoategoryTable">
            <thead>
              <tr >
                <th>Sr.No.</th>
                <th>Question</th>
                <th>Option</th>
                <th>Order No.</th>
                <th>Action</th> 
              </tr>
            </thead>
              <tbody> 
                {OptionsList}
              </tbody>
          </table>
          </div>

        
        </div>
      </div>
    );
  }
}
export default EditSubQuestion;


// WEBPACK FOOTER //
// ./src/components/demographics/editSubQuestion.js